import angular from 'angular';
import uiRouter from 'angular-ui-router';
import SalesmanComponent from './salesman.component';

let SalesmanModule = angular
  .module('Salesman', [uiRouter])

  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newSalesman', {
        url: '/salesmen/new',
        component: 'salesman',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      })
      .state('editSalesman', {
        url: '/salesmen/:id',
        component: 'salesman',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          salesman: (SalesmenService, $stateParams) => {
            return SalesmenService.findById($stateParams.id);
          }
        }
      });
  })
  .component('salesman', SalesmanComponent).name;

export default SalesmanModule;
